export default __webpack_public_path__ + "static/media/audiobg.29fda945.svg";